import { dataHooks } from '../../../libs/dataHooks';

export const headerSearchDataHooks = dataHooks<{ input }>('search');
